<template lang="pug">
div
  div(v-if="has_permission")
    modal-gallery(:is-add='isModalAdd', :gallery='gallery', :project='inOrder.id')
    .gallery-container
      file-card(:key="index" v-for="(item, index) in galleries" :data="item" :thumbnail="item.thumb_url" @attachment="reciveImage" @view="openViewer" v-if="item.mime_type.includes('image')" showDelete)
    .pagination
      vm-pagination(:total="paginationGallery.totalPages" v-model="currentPage" goto)
    .add-file(@click="addGallery" v-if="gallerys_store_permission && inOrder.status != 5")
      vm-icon(icon="plus-outline" size="1.5rem")
  #no-access(v-else)
    access-denied
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Gallery',
  components: {
    FileCard: () => import('@/components/aditionals/FileCard.vue'),
    ModalGallery: () => import('@/components/in-order/ModalGallery.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    uploadPercentage: 0,
    loading: false,
    currentPage: 1,
    isModalAdd: true,
    has_permission: true,
    gallerys_store_permission: true,
    gallery: {}
  }),
  watch: {
    currentPage (currentPage) {
      this.getGalleries(currentPage)
    }
  },
  async created () {
    this.checkPermissionView('gallerys.index')
    this.$route.params.id && await this.getGalleries(1)
  },
  methods: {
    ...mapActions([
      'setModalGalleryVisible',
      'deleteGallery',
      'loadGalleries'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.gallerys_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'gallerys.store') > -1
    },
    openViewer (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    addGallery () {
      this.isModalAdd = true
      this.gallery = { date: moment().format('YYYY-MM-DD') }
      this.setModalGalleryVisible(true)
    },
    isLoading (payload) {
      this.loading = payload
    },
    async reciveImage (image) {
      let t = this
      this.auxDeleteAttachement = () => {
        t.deleteGallery(image).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.attachment') }),
        accept: this.auxDeleteAttachement
      })
    },
    async getGalleries (page) {
      this.loadGalleries({ project_id: this.$route.params.id, page: page })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'galleries',
      'paginationGallery'
    ])
  }
}
</script>
<style lang="scss">
.gallery-container {
  padding: 20px 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr) );
  grid-gap: 15px;
}
.add-file {
  border-radius: 50%;
  background: rgb(237, 28, 36);
  position: absolute;
  height: 45px;
  width: 45px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 50px;
  bottom: 40px;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.2);
}
.add-file:hover {
  transform: scale(1.2);
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.4);
}
.hide {
  display: none;
}
.pagination {
  padding-bottom: 30px;
}
</style>
